import { SourceData } from '@/components/control/TableSelectBox'

export const BORROWER_TYPE_INDIVIDUAL: SourceData  = { value: 'INDIVIDUAL', name: '개인' }
export const BORROWER_TYPE_CORPORATION: SourceData = { value: 'CORPORATION', name: '법인' }
export const BORROWER_TYPE_ETC: SourceData         = { value: 'ETC', name: '기타' }
export const BORROWER_TYPE_SOLE_PROPRIETORSHIP: SourceData = { value: 'SOLE_PROPRIETORSHIP', name: '개인사업자' }
export const BORROWER_TYPE_LIST: SourceData[] = [
    BORROWER_TYPE_INDIVIDUAL,
    BORROWER_TYPE_SOLE_PROPRIETORSHIP,
    BORROWER_TYPE_CORPORATION,
    BORROWER_TYPE_ETC
]
